import React, { useState } from 'react';
import { Card, Form, Button, Alert, Container, Row, Col, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import ENV_CONFIG from '../config';

function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [environment, setEnvironment] = useState('dev');
  const [loading, setLoading] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setIsButtonDisabled(true);

    // Get config for selected environment
    const { baseUrl, token } = ENV_CONFIG[environment];

    try {
      const response = await fetch(`${baseUrl}/api/admin-portal/user-management/users/login`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'X-Accept-Version': 'v2',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          userName: email,
          password: password,
          requestType: 'admin-portal'
        })
      });

      if (!response.ok) {
        throw new Error('Login failed');
      }

      const data = await response.json();

      // Extract tokens from the response
      const { AccessToken, RefreshToken, IdToken } = data;

      // Extract email from the response
      const userEmail = data.me.email.value;

      // Store environment in localStorage
      localStorage.setItem('environment', environment);

      // Call the onLogin function with the user data and environment
      onLogin({ ...data, email: userEmail, environment, AccessToken, RefreshToken, IdToken });

      // Redirect to the home page or another page after login
      navigate('/');
    } catch (err) {
      setError(err.message);
      setLoading(false);
      setIsButtonDisabled(false);
    }
  };

  return (
    <Container
      className="d-flex justify-content-center align-items-center"
      style={{
        minHeight: 'calc(100vh - 64px)', // Adjust for navbar height
        height: 'calc(100vh - 64px)',    // Ensures no extra scroll
        paddingTop: 0,
        paddingBottom: 0,
      }}
    >
      <Card className="shadow" style={{ width: '100%', maxWidth: '400px' }}>
        <Card.Body>
          <h2 className="text-center mb-4">Login</h2>
          {error && <Alert variant="danger">{error}</Alert>}
          {loading && (
            <div className="d-flex justify-content-center mb-3">
              <Spinner animation="border" variant="primary" />
            </div>
          )}
          <Form onSubmit={handleSubmit}>
            <Form.Group as={Row} controlId="formEmail" className="mb-3">
              <Form.Label column sm="4" className="text-left">Email</Form.Label>
              <Col sm="8">
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="formPassword" className="mb-3">
              <Form.Label column sm="4" className="text-left">Password</Form.Label>
              <Col sm="8">
                <Form.Control
                  type="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="formEnvironment" className="mb-3">
              <Form.Label column sm="4" className="text-left">Environment</Form.Label>
              <Col sm="8">
                <Form.Control
                  as="select"
                  value={environment}
                  onChange={(e) => setEnvironment(e.target.value)}
                  required
                >
                  <option value="dev">Development</option>
                  <option value="qa">QA</option>
                  <option value="prod">Production</option>
                </Form.Control>
              </Col>
            </Form.Group>

            <Button type="submit" variant="primary" className="w-100" disabled={loading}>
              Login
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default Login;